import React from 'react';
import { Mail, Phone, MapPin, Share2 } from 'lucide-react';

const Footer = () => {

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center justify-center md:justify-start mb-4">
              <img
                src="/smartlogis-logo.png"
                alt="SmartLogis Logo"
                className="h-12 sm:h-14 md:h-16 w-auto max-w-[160px] sm:max-w-[180px] object-contain"
              />
            </div>
            <p className="text-sm text-gray-400 mb-4">
              Solutions de maison intelligente portables et abordables pour locataires à Montréal et ses environs.
            </p>
            <div className="flex space-x-3">
              <a href="#" className="w-9 h-9 bg-gray-800 hover:bg-blue-600 rounded-lg flex items-center justify-center transition-colors" title="Facebook">
                <Share2 className="w-4 h-4" />
              </a>
              <a href="#" className="w-9 h-9 bg-gray-800 hover:bg-blue-600 rounded-lg flex items-center justify-center transition-colors" title="Instagram">
                <Share2 className="w-4 h-4" />
              </a>
              <a href="#" className="w-9 h-9 bg-gray-800 hover:bg-blue-600 rounded-lg flex items-center justify-center transition-colors" title="LinkedIn">
                <Share2 className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold mb-4">Liens Rapides</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('accueil')}
                  className="text-sm hover:text-blue-400 transition-colors"
                >
                  Accueil
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('produits')}
                  className="text-sm hover:text-blue-400 transition-colors"
                >
                  Nos Produits
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-sm hover:text-blue-400 transition-colors"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('reservation')}
                  className="text-sm hover:text-blue-400 transition-colors"
                >
                  Réservation
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-sm hover:text-blue-400 transition-colors"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-white font-bold mb-4">Produits</h4>
            <ul className="space-y-2 text-sm">
              <li className="hover:text-blue-400 transition-colors cursor-pointer">Kit Débutant</li>
              <li className="hover:text-blue-400 transition-colors cursor-pointer">Kit Confort</li>
              <li className="hover:text-blue-400 transition-colors cursor-pointer">Kit Premium</li>
              <li className="hover:text-blue-400 transition-colors cursor-pointer">Ampoules Intelligentes</li>
              <li className="hover:text-blue-400 transition-colors cursor-pointer">Prises Connectées</li>
              <li className="hover:text-blue-400 transition-colors cursor-pointer">Moteurs de Rideaux</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-bold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-sm">514 464 3012</p>
                  <p className="text-xs text-gray-500">Lun-Ven: 9h-18h</p>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-sm">info@smartlogis.ca</p>
                  <p className="text-xs text-gray-500">Réponse en 24h</p>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-sm">Montréal, Québec</p>
                  <p className="text-xs text-gray-500">Québec, Canada</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-500">
              © 2024 SmartLogis. Tous droits réservés.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="hover:text-blue-400 transition-colors">Politique de Confidentialité</a>
              <a href="#" className="hover:text-blue-400 transition-colors">Conditions d'Utilisation</a>
              <a href="#" className="hover:text-blue-400 transition-colors">Garantie</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
